import React from 'react';

export const useMatchMedia = (mediaQuery: string) => {
	const getInitialMatch = () => {
		if (!mediaQuery) {
			return false;
		}
		return window.matchMedia(mediaQuery).matches;
	};
	const [match, setMatch] = React.useState(getInitialMatch);
	React.useEffect(() => {
		if (!mediaQuery) {
			return undefined;
		}
		const queryList = window.matchMedia(mediaQuery);
		const updateMatch = () => {
			setMatch(queryList.matches);
		};
		updateMatch();
		queryList.addListener(updateMatch);
		return () => {
			queryList.removeListener(updateMatch);
		};
	}, [mediaQuery]);

	return match;
};
